import React from 'react';
import { Col, Row, Button, Table, Container, Card, Modal } from 'react-bootstrap';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import Pagination from 'react-bootstrap/Pagination';
import { useState, useEffect } from 'react';
import RewardDetailModal from '../Modals/RewardModals/RewardDetailModal';
import RewardEditModal from '../Modals/RewardModals/RewardEditModal';
import RewardDelModal from '../Modals/RewardModals/RewardDelModal';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
const RewardPoints = () => {
    const [allRewards, setAllRewards] = useState([]);
    const [activeNumber, setActiveNumber] = useState(1);
    const [selectedItem, setSelectedItem] = useState();
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showDelModal, setShowDelModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [paginationBtns, setPaginationBtns] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [userData, setUserData] = useState();
    const navigate = useNavigate();
    const { user, getToken } = useAuth();
    useEffect(() => {
        getUserDetail(user);
    }, [user]);

    const getUserDetail = (user) => {
        if (user) {
            setUserData(user);
            // return JSON.parse(user);
            getAllRewards(20, 0, '', '', user?.agencyId);
        } else {
            return '';
        }
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Number of Allowed Redeems</span>
                </h6>
            ),
            selector: (row) => row.noOfAllowRedeems,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Redeem Count</span>
                </h6>
            ),
            selector: (row) => row?.redeemedCount || 0,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Required Points</span>
                </h6>
            ),
            selector: (row) => row.requiredPoints,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Validity</span>
                </h6>
            ),
            selector: (row) => (row?.validity ? moment(row?.validity).format('MM-DD-YYYY') : ''),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    value={row?.status}
                    onChange={(e) => {
                        e.preventDefault();
                        updateSingle(row?._id, { status: e.target.value });
                    }}
                    className="status-selector"
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <img
                            width={15}
                            className="me-3"
                            src={viewIcon}
                            alt=""
                            onClick={() => {
                                setSelectedItem(row);
                                navigate('/reward-points/reward-point-details', {
                                    state: {
                                        reward_id: row._id,
                                        reward_details: row
                                    }
                                });
                            }}
                        />
                    </div>
                    <div className="edit-detail">
                        <img
                            width={15}
                            className="me-3"
                            src={editIcon}
                            alt=""
                            //reward-points/edit-rewards-points
                            onClick={() => {
                                setSelectedItem(row);
                                navigate('/reward-points/edit-rewards-points', {
                                    state: {
                                        reward_id: row._id
                                    }
                                });
                                // setShowEditModal(true);
                            }}
                        />
                    </div>
                    <div className="del-detail">
                        <img
                            width={15}
                            src={delIcon}
                            alt=""
                            onClick={() => {
                                setSelectedItem(row);
                                setShowDelModal(true);
                            }}
                        />
                    </div>
                </div>
            ),
            center: true
            // sortable: true
        }
    ];
    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
        // cells: {
        //     style: {
        //         paddingLeft: '8px', // override the cell padding for data cells
        //         paddingRight: '8px'
        //     }
        // }
    };

    const getAllRewards = async (pageSize = 10, pageNo = 0, _status, _search, agencyId) => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllRewards(token, pageSize, pageNo, _status, _search, agencyId)
                .then((res) => {
                    if (res?.code === 200) {
                        setAllRewards(res?.data?.rewards);
                        // calcPagination(res?.data?.totalCount);
                        setTotalRecords(res?.data?.totalCount);
                    }
                })
                .catch((err) => {});
        }
    };

    const handleClose = () => {
        setShowDetailModal(false);
        setShowDelModal(false);
        setShowEditModal(false);
    };
    const handleDelete = async () => {
        const token = getToken();
        if (token && selectedItem?._id) {
            new WebApiCalls()
                .deleteReward(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Reward is deleted successfully.');
                        getAllRewards();
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };
    const handlePageChange = (pageNo) => {
        getAllRewards(pageSize, pageNo, '', '', userData?.agencyId);
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllRewards(pageSize, pageNo, '', '', userData?.agencyId);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        getAllRewards(undefined, undefined, '', text, userData?.agencyId);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkRewards(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRewards(undefined, undefined, '', '', userData?.agencyId);
                            setLoading(false);
                            toast.success('Rewards are Updated Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const updateSingle = async (selectedId, body) => {
        try {
            setLoading(true);
            const token = getToken();
            if (token)
                new WebApiCalls()
                    .updateReward(token, body, selectedId)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRewards(undefined, undefined, '', '', userData?.agencyId);
                            setLoading(false);
                            toast.success('Reward is  updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        } else {
                            toast.error('Oops...! Something went wrong');
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkRewards(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRewards(undefined, undefined, '', '', userData?.agencyId);
                            setLoading(false);
                            toast.success('Rewards are Delete Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                <Modal.Header closeButton onClick={handleClose}>
                    <Modal.Title className="text-center">
                        <h6 className="text-capitalize mt-2">
                            <span className=" breadcrumb-heading">Change Status</span>
                        </h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {/* <div className="icon-warning-wrapper my-1 mt-1"><img src={warningIcon} alt="" /></div> */}
                    <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                    <div className="text-content-wrapper mt-3">
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#198754' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('active');
                                }}
                            >
                                Active
                            </Button>
                        </div>
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#F32013' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('inactive');
                                }}
                            >
                                Inactive
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 mt-2"></Modal.Footer>
            </Modal>
            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Reward?'} />
            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                        }}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                    <div className="d-flex gap-10 justify-content-start">
                        <h6 className="text-capitalize mt-2 text-center">
                            {/* <span className="fw-bold" style={{ whiteSpace: 'nowrap' }}>
                            Filter By
                        </span> */}
                        </h6>
                        {/* <select
                        onChange={(e) => {
                            getAllVendors(undefined, undefined, e.target.value);
                            setIsTypeFilterSelected(e.target.value ? true : false);
                        }}
                        className="status-selector w-120"
                        aria-label="Default select example"
                        style={{ color: !isTypeFilterSelected ? '#9a9a9a' : '' }}
                    >
                        <option value={''}>Transit Type</option>
                        <option value={'bus'}>Bus</option>
                        <option value={'streetcar'}>Street Car</option>
                        <option value={'subway'}>Subway</option>
                        <option value={'train'}>Train</option>
                    </select> */}
                        <select
                            onChange={(e) => {
                                getAllRewards(undefined, undefined, e.target.value, '', userData?.agencyId);
                                setIsFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''}>Status</option>
                            <option value={'active'}>Active</option>
                            <option value={'inactive'}>Inactive</option>
                        </select>
                    </div>
                </Col>
                <Col sm={5} md={5}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: '#F3D119', color: 'black' }}
                                    onClick={(e) => {
                                        // updateBulk('active');
                                        setChangeStatusModal(true);
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Change Status
                                    {/* {activeButton} */}
                                </Button>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                        <Button
                            className="add-record-btn justify-content-center  w-140"
                            style={{ background: '#13aa61' }}
                            onClick={(e) => {
                                navigate('/reward-points/add-rewards-points', {
                                    state: {
                                        agency_id: userData?.agencyId,
                                        redirect_url: '/reward-points'
                                    }
                                });
                            }}
                        >
                            Add
                        </Button>
                    </div>
                    {/* </Col> */}
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={allRewards}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={allRewards && allRewards?.length >= 0 ? false : true}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                // defaultSortFieldId={1}
            />
        </div>
    );
};
export default RewardPoints;
